import { Toaster } from '@grupoboticario/flora-react'

const triggerToastSuccess = (error, message, callback = () => {}, withTimeout = false) => {
  if (!error) {
    Toaster.notify({
      kind: 'success',
      description: message
    })
    if (withTimeout) setTimeout(() => callback(), 1000)
    else callback()
  }
}

export default triggerToastSuccess
